import { apiCall } from '../helpers/apiHelpers';
import { ApiResult } from '../types/api/common';
import { PrintDocumentResponse } from '../types/api/responses';

interface PrintDocumentParams {
  sessionId: string;
  company: string;
  agreementId: string;
}

export const printDocumentService = ({ sessionId, company, agreementId }: PrintDocumentParams): Promise<ApiResult<PrintDocumentResponse>> =>
  apiCall<PrintDocumentResponse>({
    method: 'GET',
    url: `/client/contract/print?clientSessionId=${sessionId}&company=${company}&agreementId=${agreementId}`,
  })();
